import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { t } from '@avanta/shared/i18n';
import { isToday } from 'date-fns';
import { Calendar, User, UserCog, type LucideIcon } from 'lucide-react';
import { ENTERPRISE_ACTIVITY_TYPE } from 'constants/enterprise';
import { type EnterpriseActivityType } from 'types/enterprises';

export const ACTIVITY_ICON: Record<EnterpriseActivityType, LucideIcon> = {
  [ENTERPRISE_ACTIVITY_TYPE.PATIENT_ADDED]: User,
  [ENTERPRISE_ACTIVITY_TYPE.APPOINTMENT_BOOKED]: Calendar,
  [ENTERPRISE_ACTIVITY_TYPE.APPOINTMENT_SESSION_STARTED]: Calendar,
  [ENTERPRISE_ACTIVITY_TYPE.ADMIN_ADDED]: UserCog,
  [ENTERPRISE_ACTIVITY_TYPE.USER_LOGGED_IN]: User,
};

export const ACTIVITY_TITLE_KEY: Record<EnterpriseActivityType, string> = {
  [ENTERPRISE_ACTIVITY_TYPE.PATIENT_ADDED]: 'HomePage.activity.patientAdded',
  [ENTERPRISE_ACTIVITY_TYPE.APPOINTMENT_BOOKED]: 'HomePage.activity.appointmentBooked',
  [ENTERPRISE_ACTIVITY_TYPE.APPOINTMENT_SESSION_STARTED]:
    'HomePage.activity.appointmentSessionStarted',
  [ENTERPRISE_ACTIVITY_TYPE.ADMIN_ADDED]: 'HomePage.activity.adminAdded',
  [ENTERPRISE_ACTIVITY_TYPE.USER_LOGGED_IN]: 'HomePage.activity.userLoggedIn',
};

export const formatActivityDateTime = (occurredAt: string): string => {
  const date = new Date(occurredAt);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const time = `${hours}:${minutes}`;

  if (isToday(date)) {
    return `${t('HomePage.date.today', { ns: LOCIZE_NS.INSURANCE })}, ${time}`;
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}, ${time}`;
};
